<template>
  <component class="text-hint" :is="tag">({{ label }})</component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: "span",
    },
    label: {
      type: String,
      default: "Hint",
    },
  },
};
</script>